<template>
  <div>
    <HeaderTop page="home" :isBackgroundShow="isBackgroundShow" :isBlack="true" homeTitle="留言板"></HeaderTop>
    <div class="content" @scroll="handleScroll">
      <div class="banner">
        <img src="../../assets/img/itemimage/lybbanner.png" alt="">
        <div class="menuTitle">
          <div class="english">{{ englishTitle }}</div>
<!--          <div class="english">{{ englishTitle }}</div>-->
          <div class="chinese"> {{ chineseTitle }}</div>
        </div>
      </div>
      <div class="con">
        <div class="connectus">
          <div class="title">
            MESSAGE BOARD
          </div>
          <div class="subtitle">
            为了确保您的信息能及时得到反馈，请务必详细填写，对于您的支持，我们深表感谢
          </div>
          <div class="info">
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidateRules" :label-width="80"
                  v-if="pageWidth > 1280">
              <div class="firstRow">
                <FormItem label="姓名" prop="name">
                  <Input v-model="formValidate.name"></Input>
                </FormItem>
                <FormItem label="电话" prop="phone">
                  <Input v-model="formValidate.phone"></Input>
                </FormItem>
                <FormItem label="邮箱" prop="email">
                  <Input v-model="formValidate.email"></Input>
                </FormItem>
              </div>
              <div class="sRow">
                <FormItem label="地址" prop="address">
                  <Input v-model="formValidate.address"></Input>
                </FormItem>
              </div>
              <div class="sRow">
                <FormItem label="标题" prop="title">
                  <Input v-model="formValidate.title"></Input>
                </FormItem>
              </div>
              <div class="tRow">
                <FormItem label="" prop="content">
                  <Input v-model="formValidate.content" type="textarea" placeholder="留言内容" :rows="10"></Input>
                </FormItem>
              </div>
            </Form>
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidateRules" :label-width="50" v-else>
              <div class="firstRow">
                <FormItem label="姓名" prop="name">
                  <Input v-model="formValidate.name"></Input>
                </FormItem>
                <FormItem label="电话" prop="phone">
                  <Input v-model="formValidate.phone"></Input>
                </FormItem>
              </div>
              <div class="firstRow">
                <FormItem label="邮箱" prop="email">
                  <Input v-model="formValidate.email"></Input>
                </FormItem>
                <FormItem label="地址" prop="address">
                  <Input v-model="formValidate.address"></Input>
                </FormItem>
              </div>
              <div class="sRow">
                <FormItem label="标题" prop="title">
                  <Input v-model="formValidate.title"></Input>
                </FormItem>
              </div>
              <div class="tRow">
                <FormItem label="" prop="content">
                  <Input v-model="formValidate.content" type="textarea" placeholder="留言内容" :rows="10"></Input>
                </FormItem>
              </div>
            </Form>
            <div class="bottombtn">
              <span class="submit" @click="toCommit">提交</span>
              <span class="reset" @click="toReset">重置</span>
            </div>
          </div>

        </div>
      </div>

    </div>
    <float-element :showTop="showTop"></float-element>
    <Bottom></Bottom>
  </div>
</template>

<script>
import HeaderTop from "@/components/headerTop"
import Bottom from "@/components/bottom"
import Pagination from '@/components/pagination';
import FloatElement from "@/components/floatElement";

export default {
  name: "imglist",
  components: {
    HeaderTop,
    Bottom,
    Pagination,
    FloatElement
  },
  data() {
    return {
      pageWidth: 0,
      englishTitle: 'MESSAGE BOARD',
      chineseTitle: '在线留言',
      formValidate: {
        name: "",
        phone: "",
        email: "",
        address: "",
        title: "",
        content: "",
      },
      ruleValidateRules: {
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'}
        ],
        phone: [
          {required: true, trigger: 'blur', message: "请输入电话号码"},
        ],
        title: [
          {required: true, message: '请输入标题', trigger: 'blur'}
        ],
      },
      showTop: false,
      isBackgroundShow: true
    }
  },

  created() {

  },
  mounted() {
    this.pageWidth = document.documentElement.clientWidth
    window.addEventListener('scroll', this.handleScroll); // 添加滚动事件监听器
  },
  destroyed() {

  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll); // 移除滚动事件监听器
  },
  methods: {
    handleScroll(event) {
      const scrollTop = window.scrollY; // 获取滚动条相对于文档顶部的距离
      // 产品中心
      if (scrollTop >= 10) {
        // this.isBackgroundShow = true
        this.showTop = true
      } else {
        // this.isBackgroundShow = false
        this.showTop = false
      }
    },
    toReset() {
      this.formValidate = {
        name: "",
        phone: "",
        email: "",
        address: "",
        title: "",
        content: "",
      }
    },
    toCommit() {
      this.$refs["formValidate"].validate(valid => {
        if (valid) {
          if (this.formValidate.phone) {
            var isPhone = /^1[3456789]\d{9}$/
            var isTel = /^(([0\+]\d{2,3}-)?(0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/
            if (!isPhone.test(this.formValidate.phone) && !isTel.test(this.formValidate.phone)) {
              this.$Message.info('请输入正确的电话')
              return
            }
          }
          if (this.formValidate.email) {
            var isEmail = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/ // 较为精确的匹配
            if (!isEmail.test(this.formValidate.email)) {
              this.$Message.info('请输入正确的邮箱')
              return
            }
          }

          this.$API.InterfaceConfigurationPage._saveMessageBoard({
            name: this.formValidate.name,
            address: this.formValidate.address,
            phone: this.formValidate.phone,
            email: this.formValidate.email,
            title: this.formValidate.title,
            messagecontent: this.formValidate.content
          }).then(res => {
            if (res.success) {
              this.$Message.info('留言成功')
              this.toReset()
            } else {
              this.$Message.info('系统错误')
            }
          }).catch(err => {
            console.log('获取失败===', err);
          });

        }
      })
    }
  }
}

</script>

<style scoped lang="less">


//移动端
.content {
  width: 100%;
  padding-bottom: 300px;
  .banner {
    width: 100%;
    position: relative;
    height: 400px;

    .menuTitle {
      position: absolute;
      top: 153px;
      text-align: left;
      padding-left: 30px;

      .english {
        font-family: D-DINExp-Bold;
        font-weight: bold;
        font-size: 50px;
        text-size-adjust: none;
        color: rgba(255, 255, 255, 0.2);
        position: relative;
        z-index: 99;
        background-image: url("../../assets/img/itemimage/lybbanner.png");
        background-repeat: no-repeat;
        background-clip: text;
        -webkit-background-clip: text;
      }

      .chinese {
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 42px;
        text-size-adjust: none;
        color: #FFFFFF;
        position: relative;
        z-index: 100;
        margin-top: -50px;
      }
    }

    img {
      width: 100%;
      height: 400px;
    }

    .tab {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 40px;
      display: flex;
      background: rgba(80, 118, 175, 0.8);

      .tabItem {
        width: 33.33%;
        text-align: center;
        line-height: 40px;
        font-size: 16px;
        text-size-adjust: none;
        color: #ccc;
        cursor: pointer;
      }

      .tabItemAct {
        color: #fff;
      }
    }
  }

  .connectus {
    background-size: 100% 100%;
    margin: 30px;
    position: relative;
    padding-top: 35px;


    .title {
      height: 85px;
      width: 100%;
      text-align: center;
      font-family: D-DINExp-Bold;
      font-weight: bold;
      font-size: 50px;
      text-size-adjust: none;
      color: rgba(82, 128, 182, 0.5);
      background: url("../../assets/img/aboutUS_m.png") no-repeat center;
      background-size: contain;
      margin: 0 auto;
      line-height: 35px;
    }

    .subtitle {
      width: 100%;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 24px;
      text-size-adjust: none;
      color: #5280B6;
      padding: 0 15px;
      text-align: center;
      margin-top: 15px;
    }

    .info {
      width: 100%;
      padding: 10px 15px;
      margin: 20px auto;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 15px;
      text-size-adjust: none;
      color: #5280B6;
      padding-bottom: 50px;

      .sRow {
        margin-bottom: 30px;

        /deep/ .ivu-form-item {
          width: 100%;
          margin: 0;
        }

        /deep/ .ivu-input {
          margin: 0;
          width: 100%;
          height: 40px;
          border-radius: 10px;
          border: 1px solid #5280B6;
        }
      }

      .tRow {
        margin-bottom: 30px;

        /deep/ .ivu-form-item {
          margin: 0;
          width: 100%;
        }

        /deep/ .ivu-input {
          margin: 0;
          width: 100%;
          border-radius: 10px;
          border: 1px solid #5280B6;
        }
      }

      .firstRow {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;

        /deep/ .ivu-form-item {
          margin: 0;
          width: 50%;
        }

        /deep/ .ivu-input {
          margin: 0;
          width: 100%;
          height: 40px;
          border-radius: 10px;
          border: 1px solid #5280B6;
        }
      }

      .bottombtn {
        padding: 10px;
        text-align: center;

        .submit {
          display: inline-block;
          width: 160px;
          text-align: center;
          line-height: 40px;
          height: 40px;
          background: #5280B6;
          border-radius: 10px;
          color: #fff;
          cursor: pointer;
          margin-right: 30px;
        }

        .reset {
          display: inline-block;
          width: 160px;
          text-align: center;
          line-height: 40px;
          height: 40px;
          background: rgba(221, 230, 241, 1);
          border-radius: 10px;
          cursor: pointer;
        }
      }
    }

  }
}

//PC端
@media screen and (min-width: 1280px) {
  .content {
    width: 100%;
    padding-bottom: 0px;
    margin-top: 100px;

    .banner {
      width: 100%;
      height: 500px;
      position: relative;

      .menuTitle {
        width: 1400px;
        margin: 0 auto;
        margin-top: -388px;
        padding: 0;
        position: static;

        .english {
          font-family: D-DINExp-Bold;
          font-weight: bold;
          font-size: 65px;
          color: rgba(255, 255, 255, 0.2);
          position: relative;
          z-index: 99;
          background-image: url("../../assets/img/itemimage/lybbanner.png");
          background-repeat: no-repeat;
          background-clip: text;
          -webkit-background-clip: text;
        }

        .chinese {
          font-family: Microsoft YaHei;
          font-weight: bold;
          font-size: 54px;
          color: #FFFFFF;
          position: relative;
          z-index: 100;
          margin-top: -55px;
        }
      }

      img {
        width: 100%;
        height: 100%;
      }

      .tab {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 50px;
        display: flex;
        background: rgba(80, 118, 175, 0.8);

        .tabItem {
          width: auto;
          text-align: center;
          line-height: 50px;
          font-size: 20px;
          color: #ccc;
        }

        .tabItemAct {
          color: #fff;
        }
      }
    }
    .con {
      .connectus {
        max-width: 1280px;
        //height: 661px;
        background: url("../../assets/img/itemimage/lybbox.png") 100% 100%;
        background-size: 100% 100%;
        margin: 68px auto 20px;
        position: relative;
        padding-top: 68px;


        .title {
          position: absolute;
          //left: 18.5%;
          top: 10px;
          font-family: D-DINExp-Bold;
          font-weight: bold;
          font-size: 100px;
          color: rgba(82, 128, 182, 0.5);
          background: none;
          height: auto;
          line-height: 0;
        }

        .subtitle {
          width: 100%;
          font-family: Microsoft YaHei;
          font-weight: bold;
          font-size: 24px;
          color: #5280B6;
          margin-top: 5px;
        }

        .info {
          width: 100%;
          padding: 18px 50px;
          margin: 20px auto;
          font-family: Microsoft YaHei;
          font-weight: bold;
          font-size: 15px;
          color: #5280B6;

          .sRow {
            margin: 0;
            margin-bottom: 30px;
            /deep/ .ivu-form-item {
              width: 100%;
            }

            /deep/ .ivu-input {
              border: 1px solid #5280B6;
              height: 40px;
            }
          }

          .tRow {
            margin: 0;
            margin-bottom: 30px;
            /deep/ .ivu-form-item {
              width: 100%;
            }

            /deep/ .ivu-input {
              border: 1px solid #5280B6;
            }
          }

          .firstRow {
            display: flex;
            margin: 0;
            margin-bottom: 30px;

            /deep/ .ivu-form-item {
              width: 100%;
            }

            /deep/ .ivu-input {
              border: 1px solid #5280B6;
              height: 40px;
            }

            .ivu-form-item {
              width: 33.33%
            }
          }

          .bottombtn {
            padding: 10px;
            text-align: center;
            padding-bottom: 45px;

            .submit {
              display: inline-block;
              width: 200px;
              text-align: center;
              line-height: 60px;
              height: 60px;
              background: #5280B6;
              border-radius: 10px;
              color: #fff;
              cursor: pointer;
              margin-right: 35px;
            }

            .reset {
              display: inline-block;
              width: 200px;
              text-align: center;
              line-height: 60px;
              height: 60px;
              background: rgba(221, 230, 241, 1);
              border-radius: 10px;
              cursor: pointer;
            }
          }
        }

      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/aboutUs/messageBoard.vue